import script from "./SavedFlyers.vue?vue&type=script&setup=true&lang=js"
export * from "./SavedFlyers.vue?vue&type=script&setup=true&lang=js"

import "./SavedFlyers.vue?vue&type=style&index=0&id=18380d80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18380d80"]])

export default __exports__